
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/separator/styles.css.ts.vanilla.css\",\"source\":\"Ll8xZDkyZXlyMCB7CiAgZGlzcGxheTogZmxleDsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIHRleHQtYWxpZ246IGNlbnRlcjsKICBnYXA6IDEwcHg7Cn0KLl8xZDkyZXlyMSB7CiAgY29sb3I6ICNFMkUyRTI7CiAgYm9yZGVyOiAwLjFweCBzb2xpZCAjRTJFMkUyOwogIGJvcmRlci13aWR0aDogMC4xcHg7CiAgcGFkZGluZzogMCAxMHB4OwogIHdpZHRoOiA1MHB4Owp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/separator/styles.css.ts.vanilla.css\",\"source\":\"Ll8xZDkyZXlyMCB7CiAgZGlzcGxheTogZmxleDsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIHRleHQtYWxpZ246IGNlbnRlcjsKICBnYXA6IDEwcHg7Cn0KLl8xZDkyZXlyMSB7CiAgY29sb3I6ICNFMkUyRTI7CiAgYm9yZGVyOiAwLjFweCBzb2xpZCAjRTJFMkUyOwogIGJvcmRlci13aWR0aDogMC4xcHg7CiAgcGFkZGluZzogMCAxMHB4OwogIHdpZHRoOiA1MHB4Owp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
